<template>
  <multiselect :key="multiple ? 'multiple' : 'single'" :model-value="selection" @update:model-value="$emit('input', $event)"
               :options="options" :mode="multiple ? 'tags' : 'single'" :break-tags="multiple"
               :object="true" :label="label" :value-prop="valueProp" :track-by="label"
               :searchable="true" :close-on-select="!multiple" :loading="loading"
               :placeholder="placeholder" :disabled="disabled"
               @search-change="search"></multiselect>
</template>

<script>
import Multiselect from '@vueform/multiselect'

export default {
  components: { Multiselect },
  props: {
    value: { default: null },
    options: { type: Array, default: () => [] },
    multiple: Boolean,
    disabled: Boolean,
    label: { type: String, default: 'label' },
    valueProp: { type: String, default: 'value' },
    placeholder: { type: String, default: '' }
  },
  emits: ['input', 'search'],
  data () {
    return { loading: false }
  },
  computed: {
    selection () {
      if (this.multiple) return Array.isArray(this.value) ? this.value : []
      if (this.value == null || this.value === '') return null
      if (typeof this.value === 'object') return this.value
      return this.options.find(option => String(option[this.valueProp]) === String(this.value)) || null
    }
  },
  methods: {
    search (query) {
      this.$emit('search', query, loading => { this.loading = loading })
    }
  }
}
</script>
